import { useRef, useEffect } from "react";

export function usePrevious<T>(value: T): T | undefined {
  const ref = useRef<undefined | T>(undefined);
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}
